import { jsx as _jsx } from "react/jsx-runtime";
import useRewards from '../../../../../hooks/useRewards';
import RewardsFaqs from '../../../../../ui/atoms/RewardsFaqs';
var ModalRewardsFaqs = function () {
    var _a;
    var _b = useRewards(), clientId = _b.clientId, rewardsExperience = _b.rewardsExperience;
    var faqsSnapshot = (_a = rewardsExperience === null || rewardsExperience === void 0 ? void 0 : rewardsExperience[clientId]) === null || _a === void 0 ? void 0 : _a.faqsSnapshot;
    return faqsSnapshot ? _jsx(RewardsFaqs, { className: "inside-drawer" }) : null;
};
export default ModalRewardsFaqs;
